<template>
    <div class="audioInfoWrapper">
        <div class="title" :style="{background: `url(${list.cover}) center center/120% no-repeat`}">
            <div class="titleContent">
                <div class="titleImg">
                    <img :src="list.cover" alt="" class="cover">
                    <img src="~@/assets/img/FMlogo.png" alt="喜马拉雅" class="FMlogo">
                </div>
                <div class="source">来源：{{list.source}}</div>
            </div>
        </div>

        <div class="content">
            <div v-for="(it, ix) in list.columns" class="columns" @click="handleAudioDetail(it.id, it.track_title, ix)">
                <div class="columnsTitle">{{it.track_title}}</div>
                <div class="columnsInfo">
                    <div class="time"><img src="~@/assets/img/clock.png" alt=""></div>
                    <div class="columnsDuration">{{formatTime(it.duration)}}</div>
                    <div class="columnsPublish">{{formatDateTime(it.updated_at)}}</div>
                </div>
            </div>
            <div v-if="isLoading" class="over">
<!--                <img src="~@/assets/img/loading1.gif" alt="">-->
                加载中...
            </div>
            <div v-if="isOver && !isLoading" class="over">
                没有更多了~
            </div>
        </div>
    </div>
</template>

<script>
    import {formatAudioTime, formatMonthDay, ximalayaDetailTemplate} from '@/utils/utils'
    import {mapMutations, mapState, mapActions} from "vuex";
    export default {
        name: "XimalayaAudioInfo",
        props: {
            list: {
                type: Object,
                default: ()=> {}
            },
            refresh: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                page: 1,
                columns: [],
                isLoading: false,
                isOver: false,
                totalColumns: [],
            }
        },
        created() {
            this.columns = this.list.columns
            // 获得该专辑下所有的栏目
            this.queryXimalayaList({payload: {id: this.readNewsId, page: 1, pageSize: 200}}).then((res)=>{
                let columns =  res[1].content.list
                if(columns.length !== 0){
                    this.totalColumns.push(...columns)
                }
            })
        },
        watch: {
            refresh(value){
                if(value){
                    this.isLoading = true
                    this.queryXimalayaList({payload: {id: this.readNewsId, page: this.page + 1, pageSize: 10}}).then((res)=>{
                        this.isLoading = false
                        this.page += 1
                        let columns =  res[1].content.list;
                        if(columns.length !== 0){
                            this.columns.push(...columns)
                        } else {
                            this.isOver = true
                        }

                    })
                }
            },
            list(value){
                this.page = 1
                this.columns = value.columns
                this.totalColumns = []
                // 获得该专辑下所有的栏目
                this.queryXimalayaList({payload: {id: this.readNewsId, page: 1, pageSize: 200}}).then((res)=>{
                    let columns =  res[1].content.list
                    if(columns.length !== 0){
                        this.totalColumns.push(...columns)
                    }
                })
            }
        },
        computed: {
            ...mapState('audio', ["audioCurrentIndex"]),
            ...mapState(["readNewsId"])
        },
        methods: {
            ...mapMutations('audio', ["setAudioCurrentIndex", "setAudioCurrentTime"]),
            ...mapMutations(['contactDisData', "setToastShow"]),
            ...mapActions(["queryXimalayaList", "asyncEnterAudio"]),
            handleAudioDetail(id, name, index){
                // console.log('进入音频详情', name)
                // console.log('======', this.totalColumns)
                let audioTemplate = ximalayaDetailTemplate(this.totalColumns, name)
                this.setToastShow(false)
                this.setAudioCurrentIndex(index)
                this.setAudioCurrentTime(0)
                this.asyncEnterAudio()
                this.contactDisData([{content: {right: true, tips: "音频详情"}}])
                this.contactDisData(audioTemplate);
            },
            formatTime(time){
                return formatAudioTime(time)
            },
            formatDateTime(date){
                return formatMonthDay(date)
            }
        }
    }
</script>

<style scoped lang="less">
    .audioInfoWrapper{
        .title{
            width: 100%;
            height: 4.22rem;
            background-color: rgb(9, 23, 79) !important;
            border-radius: .5rem .5rem 0 0;
            /*position: fixed;*/
            position: absolute;
            left: 0;
            right: 0;
            z-index: 10;
        }
        .titleContent{
            width: 100%;
            /*position: absolute;*/
            height: 4.27rem;
            display: flex;
            /*top: -.02rem;*/
            /*left: 0;*/
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: rgba(9,23,79, .7);
            border-radius: .5rem .5rem 0 0;
            z-index: 11;
            .titleImg{
                width: 2.13rem;
                border-radius: 0.16rem;
                height: auto;
                background-color: rgba(37, 88, 246, .2);
                position: relative;
                .cover{
                    border-radius: 0.16rem;
                    display: block;
                }
                .FMlogo{
                    position: absolute;
                    width: 1.5rem;
                    bottom: 0;
                    right: -.05rem;
                }
            }
            .source{
                margin-top: .43rem;
                color: #fff;
                font-size: 0.43rem;
            }
        }
        .content{
            position: relative;
            top: 4.27rem;
            min-height: 11rem;
            overflow-y: auto;
            .columns{
                margin: 0 0.43rem;
                padding: .43rem 0;
                border-bottom: 0.03rem solid rgb(230, 230, 230);
                .columnsTitle{
                    font-size: 0.48rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #171E32;
                    line-height: 0.69rem;
                }
                .columnsInfo{
                    font-size: 0.32rem;
                    color: #999999;
                    line-height: 0.32rem;
                    margin-top: .45rem;
                    .time{
                        display: inline-block;
                        width: .32rem;
                        height: .32rem;
                        top: .02rem;
                        position: relative;

                    }
                    .columnsDuration{
                        display: inline-block;
                        margin-left: .16rem;
                    }
                    .columnsPublish{
                        display: inline-block;
                        margin-left: .56rem;
                    }
                }
            }
            .loading{
                margin: 0 auto;
                width: 3rem;
            }
            .over{
                font-size: .32rem;
                color: #999999;
                text-align: center;
                line-height: 1rem;
            }
        }
    }
</style>
